import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useSubsidiariesApi } from "../../http/subsidiaries/api";
import { Subsidiary, UpsertIsoCode } from "../../http/subsidiaries/types";
import ModalDialog from "../ui/ModalDialog";
import SetSubsidiaryIsoCodeForm, { SubsidiaryIsoCodeFormBody } from "./SetSubsidiaryIsoCodeForm";

type SetIsoCodeDialogProps = {
  subsidiary: Subsidiary;
  onClose: () => void;
  onUpdate: () => void;
};

const SetIsoCodeDialog: FC<SetIsoCodeDialogProps> = ({ subsidiary, onClose, onUpdate }: SetIsoCodeDialogProps) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const subsidiariesApi = useSubsidiariesApi();

  const onSubmit = async (formData: SubsidiaryIsoCodeFormBody): Promise<void> => {
    const body: UpsertIsoCode = {
      countryIsoCodeAlpha2: formData.countryIsoCodeAlpha2,
      currentVersionNumber: subsidiary.versionNumber,
    };

    setIsSubmitting(true);
    try {
      await subsidiariesApi.setIsoCode(subsidiary.id, body);
      dispatch(showSuccessNotification(i18n.t));
      onUpdate();
      onClose();
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalDialog onClose={onClose} title={i18n.t.common.setIsoCode}>
      <SetSubsidiaryIsoCodeForm
        onSubmit={onSubmit}
        isDisabled={isSubmitting}
        isLoading={!subsidiary}
        subsidiary={subsidiary}
      />
    </ModalDialog>
  );
};

export default SetIsoCodeDialog;
